import type { IconData } from '@stacksjs/iconify-core'

export const mu4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#00a04d\" d=\"M0 360h640v120H0z\"/><path fill=\"#151f6d\" d=\"M0 120h640v120H0z\"/><path fill=\"#ee2737\" d=\"M0 0h640v120H0z\"/><path fill=\"#ffcd00\" d=\"M0 240h640v120H0z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default mu4x3
